import React from 'react'

export default function useRovingFocus(itemCount, getItemId) {
  const [activeIndex, setActiveIndex] = React.useState(0)

  React.useEffect(() => {
    if (itemCount > 0 && activeIndex > itemCount - 1) {
      setActiveIndex(itemCount - 1)
    }
  }, [itemCount, activeIndex])

  const onKeyDown = React.useCallback(
    e => {
      if (itemCount === 0) {
        return
      }

      let nextIndex

      if (e.key === 'ArrowDown') {
        nextIndex = Math.min(activeIndex + 1, itemCount - 1)
      } else if (e.key === 'ArrowUp') {
        nextIndex = Math.max(activeIndex - 1, 0)
      } else if (e.key === 'Home') {
        nextIndex = 0
      } else if (e.key === 'End') {
        nextIndex = itemCount - 1
      } else {
        return
      }

      e.preventDefault()
      setActiveIndex(nextIndex)
      document.getElementById(getItemId(nextIndex))?.focus()
    },
    [activeIndex, itemCount, getItemId]
  )

  const getTabIndex = React.useCallback(
    index => (index === activeIndex ? 0 : -1),
    [activeIndex]
  )

  const onItemFocus = React.useCallback(index => setActiveIndex(index), [])

  return { onKeyDown, getTabIndex, onItemFocus }
}
